export const PROTEIN_CREATION_FLOW_SCREEN = 'PROTEIN_CREATION_FLOW_SCREEN';
